module.exports = __webpack_public_path__ + "static/media/2 Card Teen patti.369e7b98.jpg";